import imgCoin from '@assets/web-v3-images/icons/crown-coin-icon.png';
import imgProgressThumb from '@assets/web-v3-images/process-thumb1.png';
import imgProgress from '@assets/web-v3-images/progress-img.png';

export default function ProgressBar({ value, target, milestones }) {
	const max = milestones?.[milestones.length - 1] ?? target ?? 1;
	const clamped = Math.max(0, Math.min(value, max));
	const fillPercent = (clamped / max) * 100;

	const rightGap = 28;
	const trackInset = 15;

	return (
		<div className="w-full">
			<p className="text-[rgba(113,59,18,1)] font-bold text-[38px] mb-4">
				{clamped.toLocaleString('en-US')} / {target.toLocaleString('en-US')} LP
			</p>

			<div className="relative" style={{ paddingRight: `${rightGap}px` }}>
				{/* track */}
				<div className="relative h-10 rounded-full overflow-hidden">
					<img src={imgProgress} alt="" className="absolute inset-1 object-cover" />
					<div
						className="absolute rounded-full overflow-hidden transition-[width] duration-700 ease-out"
						style={{
							top: '14px',
							bottom: '7.5px',
							left: `${trackInset}px`,
							width: `calc(${fillPercent}% - ${trackInset}px)`,
							backgroundImage: `url(${imgProgressThumb})`,
							backgroundRepeat: 'repeat-x',
							backgroundSize: 'auto 100%',
						}}
					/>
				</div>

				{/* markers */}
				<div className="relative mt-2 h-12">
					{milestones?.map((m, i, arr) => {
						const isLast = i === arr.length - 1;
						// cùng thang đo với fillPercent, cộng thêm trackInset để khớp điểm vật lý với thanh fill
						const pct = `calc(${(m / max) * 100}% - ${trackInset}px)`;
						const isActive = m === target;

						return (
							<div
								key={`${m}-${i}`}
								className="absolute flex flex-col -top-13 items-center -translate-x-1/2"
								style={{ left: pct }}
							>
								<div className="relative w-[52px] h-[52px] flex items-center justify-center">
									{isActive && (
										<>
											<span
												aria-hidden="true"
												className="pointer-events-none absolute -inset-[clamp(4px,1cqw,10px)] rounded-full bg-[#f1ce5a] blur-[clamp(4px,1cqw,10px)] animate-halo"
											/>
											<span
												aria-hidden="true"
												className="pointer-events-none absolute -inset-[clamp(0px,0.2cqw,2px)] rounded-full bg-[#ffffc9] blur-[clamp(1px,0.4cqw,4px)] animate-halo"
											/>
										</>
									)}

									<img src={imgCoin} alt="" className="relative z-10 w-[52px]" />
								</div>

								<span
									className={`mt-2 whitespace-nowrap text-[22px] font-bold text-[rgba(113,59,18,1)] ${isLast ? '-translate-x-6' : ''
										}`}
								>
									{m.toLocaleString('en-US') + " LP"}
								</span>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}